import React, { Component } from "react";
import ReactHtmlParser from "react-html-parser";
import { Link } from "react-router-dom";
import Header from "./Header";
import Menu from "./Menu";
import "../assets/css/patient-symptom.css";
import { arrayExpression, thisTypeAnnotation } from "@babel/types";
import {CONFIG, URLS, getAge, makeProfileSummary, isTrueOrFalse, sentenceCase,encryptPHI,decryptPHI} from "../helpers/Common";
import { Modal , Container} from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.css";
import $ from "jquery";

class PatientNarrative extends Component {
  constructor(props) {
    super(props);
    this.state = {
      answersData: "",
      narrativeSummary: "",
      allComplains:[],
      completeNarrative:[],
      profileSummary: "",
      addNarrativeStep: 2,
      imgPath: CONFIG.COMPLAIN_IMAGE_PATH,
      getComplainLocationData:this.props.getComplainLocationData,
      nextStep: 6,
      prevStep: 4,
      show: false,

    };
    this.addAnotherNarrative    = this.addAnotherNarrative.bind(this);
    this.handleUpdateAction     = this.handleUpdateAction.bind(this);
    this.getAge                 = getAge.bind(this);
    this.makeProfileSummary     = makeProfileSummary.bind(this);

  }

  componentWillMount() {
    console.log('All complians props at 1st ',this.props.getAllComplains);

    // const all_complains_data=this.props.getAllComplains;
    this.setState({...this.state,allComplains:this.props.getAllComplains});

    const patientAnswerData = this.props.getQuestionAnswersData.filter(
      val => val
    );
    let profileData = this.props.getProfileData;
    let narrativeSummary = "";

    // Get narrative summary of latest question answers data 

    if (!patientAnswerData)
    {
        this.history.push(URLS.master);
        // Object.values(patientAnswerData).forEach(function(row, key) {
        //     narrativeSummary += row.narrative_text+". ";
        // });
        // this.setState({
        //     narrativeSummary: narrativeSummary
        // });
    }


    // Save question answers data into strage and Extract Summray or previous Question Answers

    // console.log("===CheckedItem",this.props.checkedItems);

    let saveData = new Array();
    //patientAnswerData['complainLocationData']  = this.props.getComplainLocationData;
    //patientAnswerData['complainType']          = this.props.getComplainData.complain_types;
    saveData.push({
      'optionData':patientAnswerData,
      'complain_type':this.props.getComplainData.complain_types,
      'complain_type_name':this.props.getComplainData.complainTypeDetails.name,
      'complainLocationData':this.props.getComplainLocationData,
      'surgeon_id':this.props.surgeon_id,
      'checkedItems': JSON.stringify(Array.from(this.props.checkedItems.entries()))
    });
    let data = localStorage.getItem("data");

    if(data)
    {
      var decryptedData = decryptPHI(CONFIG.ENCRYPTION_KEY,data);
      data = JSON.parse(decryptedData);
      // console.log('In second or in Edit Complain At Narrative data')
      // Get previous narrative summary from strage

      let flag=false;

      Object.values(data).forEach((item,key)=>{

        // console.log(item.complain_type , "ITEMCOMPLAINTYPES");
        // console.log(this.props.getComplainData.complain_types , "PROPSCOMPLAITYPES");


        if(parseInt(this.props.getComplainData.complain_types) === parseInt(item.complain_type)){

          // console.log("LocalDB Matched");
          data[key]['primary_complain']=0;
          data[key]=saveData[0];
          flag=true;
        }

      });
      // ???
      if(!flag){

        saveData[0]['primary_complain']=0;

        // Add Question Data in Storage array
      // ???
        data.push(saveData[0]);

      }


    }
    else
    {
      // Add Question Data if user create 1st Complain
      // console.log('In first Complain At Narrative data')

      saveData[0]['primary_complain']=1;
      data = saveData;
    }
    console.log('here is Narative saveData',saveData);

    // console.log("MISSINGDATA");
    // console.log(data);

    // Save data into storage
    var encryptedData = encryptPHI(CONFIG.ENCRYPTION_KEY,JSON.stringify(data));
    localStorage.setItem("data", encryptedData);
    
    // console.log('data is:',data)
    // Sort Summary by category order and save
    let summryData = new Array();

    let ref=this;
      if(data.length>0){
            // console.log("Current data",data)
            // console.log('data lenght -1 optiondata',data[data.length-1].optionData)
          summryData = new Array();
          Object.values(data[data.length-1].optionData).forEach(function(row2, key) {

            

            // console.log("MYROW2")
            //  console.log('row 2 is here',row2)

            if(Array.isArray(row2)){

              if(row2.length>1){

                // array 0
                // >0
                // pprefix+array split ,+postfix
                let narrativeText=row2[0].prefix +" ";
                // console.log('narrative text 1: Prefix: ',narrativeText)
                row2.forEach((rowItem,key)=>{
                 
                  rowItem.narrative_text = rowItem.narrative_text.replace('<x>',rowItem.required_input_text);
                  
                  if(key === row2.length-1){

                    narrativeText=" " + narrativeText + " and " + rowItem.single_line_text;
                    // console.log('narrative text 2: and : ',narrativeText)


                  }else{

                    narrativeText=" " + narrativeText + rowItem.single_line_text;
                // console.log('narrative text 3 : else: ',narrativeText)

                    if(key !== (row2.length)-2)
                    {
                      narrativeText=" " + narrativeText+ ", "
                    }
                // console.log('narrative text 4: all , here ',narrativeText)
 
                  }

                });

                //narrativeText =" " + narrativeText + " "+ row2[0].postfix;
                if(row2[0].postfix == '.' || row2[0].postfix == '?' || row2[0].postfix == '.<br>'|| row2[0].postfix == '. <br>'|| row2[0].postfix == '?<br>'|| row2[0].postfix == '? <br>'|| row2[0].postfix =='. <br> <br>'|| row2[0].postfix =='? <br> <br>'|| row2[0].postfix =='.<br> <br>'|| row2[0].postfix =='?<br> <br>')
                {
                  narrativeText =" " + narrativeText+row2[0].postfix;
                }else{
                  narrativeText =" " + narrativeText + " "+ row2[0].postfix;
                }
                // console.log('narrative text 5: space here: ',narrativeText)

                // summryData=[...summryData,{'narrative':narrativeText,'order':row2[0].sort_order,'id':row2.question_id}];
                summryData.push({'narrative':narrativeText,'order':row2[0].sort_order,'id':row2[0].question_id});

              }else{

                // console.log("MYROWNEW1");
                // console.log(row2[0]);
                summryData.push({'narrative':row2[0].narrative_text,'order':row2[0].sort_order,'id':row2[0].question_id});

              }

            }else {
              row2.narrative_text = row2.narrative_text.replace('<x>',row2.required_input_text);
              if(profileData.gender=='Male')
              {
                row2.narrative_text =  row2.narrative_text.replace('<his/her>', 'his');
              }
              else
              {
                row2.narrative_text =  row2.narrative_text.replace('<his/her>', 'her');
              }
              summryData.push({'narrative':row2.narrative_text,'order':row2.sort_order,'id':row2.question_id});

            }

          });
          summryData.sort((a, b) => a.order - b.order);
          summryData.sort((a, b) => a.id - b.id);
          Object.values(summryData).forEach(function(_row, _key)
          {

            if(_key == 0)
            {
              _row.narrative = '';
            }
            //console.log('row: ',_row)
            narrativeSummary += _row.narrative+" ";
          });
          // Add spacing between complains
          narrativeSummary +="<br><br><br>"
          //summryData.push({'narrative':'</br></br>'});

      }


    let {_profileSummary,image_and_points} = makeProfileSummary(profileData,data);
    // console.log('here is image_and_points declaration',image_and_points)
    _profileSummary = _profileSummary.replace('neck and arm pain','neck pain');
    let myNarrativeData="";
      // console.log("this.props.narrativeData Patient Narrative",this.props.narrativeData)
    Object.values(this.props.narrativeData).forEach((item,key)=>{

      if(key!==0){
        myNarrativeData+=" " + item;

      }
    });

    this.setState({...this.state,allComplains:[...this.state.allComplains,{narrativeSummary: _profileSummary +"<br><br>"+narrativeSummary , image_and_points , myNarrativeData } ]});
    // console.log("ALL_COMPLAINS_ARRAY");
    // console.log(this.state.allComplains);
    // let _profileSummary =  makeProfileSummary(profileData,data);
    //  let _profileSummary = profileData.title+" ";
    // _profileSummary += profileData.first_name+" ";
    // _profileSummary += profileData.last_name+" ";
    // let year  = profileData.dob;
    // let month  = profileData.dob;
    // let day  = profileData.dob;
    // year = year.substr(0,4);
    // month = month.substr(5,2);
    // day = day.substr(8,2);

    // let date = month+"/"+day+"/"+year;


    // date = getAge(date);
    // let gender = (profileData.gender).toLowerCase();
    // _profileSummary += "is a "+date+" "+gender+" ";
    // _profileSummary += "has narrated ";
    // if(gender=='male')
    // {
    //   _profileSummary += "his ";
    // }
    // else
    // {
    //   _profileSummary += "her ";
    // }
    // _profileSummary += "complain which is stated here. <br><br>";
    // let _profileSummary = profileData.title+" ";
    // _profileSummary += profileData.first_name+" ";
    // _profileSummary += profileData.last_name+" ";
    // _profileSummary += (profileData.gender).toLowerCase()+" ";

    // _profileSummary += date+" ";
    narrativeSummary =  narrativeSummary.replace('<title>', profileData.title);
    narrativeSummary =  narrativeSummary.replace('<name>', profileData.first_name+" "+profileData.last_name);

    if(profileData.gender=='Male')
    {
      narrativeSummary =  narrativeSummary.replace('<his/her>', 'his');
      narrativeSummary =  narrativeSummary.replace('<he/she>', 'he');
    }
    else
    {
      narrativeSummary =  narrativeSummary.replace('<his/her>', 'her');
      narrativeSummary =  narrativeSummary.replace('<he/she>', 'she');
    }
    
    //narrativeSummary = sentenceCase(narrativeSummary)

    // console.log('At the end summry 2: ',narrativeSummary) 
    this.setState({ 
      narrativeSummary:_profileSummary+"<br><br>"+narrativeSummary
    });
    this.props.setNarrativeSummary(_profileSummary+narrativeSummary);
    console.log('At last image_and_points are',image_and_points)
    this.props.setAllComplains({profileSummary: _profileSummary ,narrativeSummary: narrativeSummary , image_and_points , myNarrativeData });
    //this.history.push('/master');
    console.log('All complians props at 2nd ',this.props.getAllComplains); 


  }

 
  addAnotherNarrative = e => {
    this.props.setQuestionAnswersData(new Array());
    this.props.setCheckedItems(new Map());
    this.props.handleNextPrevSteps(this.state.addNarrativeStep);
    this.props.setSelectedComplains(this.props.getComplainData.complain_types);
    this.props.setIsModify(false);
    this.props.addAnotherComplain(true);
  };

  handleAction = e => {

    $(".marker").remove();

    this.props.handleNextPrevSteps(this.state.nextStep);
  };
  handleUpdateAction = (e)=>
  {
    $(".marker").remove();
    // Remove last question answer data from storage
    localStorage.setItem('editQuest',true)
    localStorage.setItem('saveQuest',true)
    let data = localStorage.getItem("data");
    if(data)
    {
      var decryptedData = decryptPHI(CONFIG.ENCRYPTION_KEY,data);
      data = JSON.parse(decryptedData);
     
      // data.splice((data.length)-1, 1);
      var encryptedData = encryptPHI(CONFIG.ENCRYPTION_KEY,JSON.stringify(data));
      localStorage.setItem("data", encryptedData); 
    }

    //Set NarrativeUpdate state from props
    this.props.setIsNarrativeUpdate(true);
    this.props.setIsModify(true);
    this.props.addAnotherComplain(false);
    this.props.setSelectedComplains(this.props.getComplainData.complain_types);
    this.props.handleNextPrevSteps(2);
  }

  handleClose = () => {
    this.setState({ show: false });
  }

  handleShow = () => {
    this.setState({ show: true });
  }

  markPosition=()=>{

    if(this.state.getComplainLocationData.selectedLocation === undefined || this.state.getComplainLocationData.selectedLocation.length == 0){

    }else{

      this.state.getComplainLocationData.selectedLocation.map((item)=>{

        if(item.picCoordinates === undefined){

          var picCoordinates = document.getElementById('pic').getBoundingClientRect();

          this.mark(item.id,picCoordinates,item.coordinate_y,item.coordinate_x);

        }else{

          this.mark(item.id,item.picCoordinates,item.coordinate_y,item.coordinate_x);

        }

      });

    }

    };


  markPositionForLoop=(selectedLocations,makerKey)=>{

    if(selectedLocations === undefined || selectedLocations.length == 0){

    }else{

      selectedLocations.map((item)=>{

        if(item.picCoordinates === undefined){

          var picCoordinates = document.getElementById('pic').getBoundingClientRect();

          this.mark(item.id,picCoordinates,item.coordinate_y,item.coordinate_x,makerKey);

        }else{

          this.mark(item.id,item.picCoordinates,item.coordinate_y,item.coordinate_x,makerKey);

        }

      });

    }

  };

  mark=(markerId, picCoordinates, top, left)=>{
    let markerRadius = 13;
    // console.log('top',top + 'bottom',left)
    // $(".marker").remove();
    $(".male-img").append(
        $('<div class="marker marker'+ markerId + '"></div>').css({
          position: "absolute",
          top: `calc(${top}px - (${markerRadius}px / 2))`,
          left: `calc(${left}px - (${markerRadius}px / 2))`,
          width: markerRadius + 'px',
          height: markerRadius + 'px',
          backgroundColor: "#990000",
          borderRadius: '50%',
          display: 'inline-block',
        })
    );
  }

  mark=(markerId, picCoordinates, top, left,markerKey)=>{
    let markerRadius = 13;
    // console.log('top',top + 'bottom',left)
    // $(".marker").remove();
    // console.log(`.male-img${markerKey}`);
    $(`.male-img${markerKey}`).append(
        $('<div class="marker marker'+ markerId + '"></div>').css({
          position: "absolute",
          top: `calc(${top}px - (${markerRadius}px / 2))`,
          left: `calc(${left}px - (${markerRadius}px / 2))`,
          width: markerRadius + 'px',
          height: markerRadius + 'px',
          backgroundColor: "#990000",
          borderRadius: '50%',
          display: 'inline-block',
        })
    );
  }
  componentDidMount(){
    console.log('Props in component did mount ',this.props.getAllComplains);

  }
  componentWillReceiveProps(nextProps){
    if(nextProps.getAllComplains!==this.props.getAllComplains){

    
    console.log("props check",nextProps.getAllComplains)
    }
  }
  render() {
    console.log('this is narrative all ',this.props.getAllComplains);

    // this.markPosition();

    const { title, first_name , last_name , dob , email ,gender , phone } = this.props.getProfileData;


    let ref = this;

    return (
      <React.Fragment>
        <Header
          title="Patient Symptoms Narrative"
          titleImage="ic-medical-result.png"
        />
        <Menu />

        <section className="patient-symptom">
          <div className="container">
            <div className="patient-txt">
              <div className="row">
                <div className="col-md-3">
                  <div className="narrative-img">
                    <img
                      src={require("../assets/img/icons/female-doctor.png")}
                      alt=""
                    />
                    <h2 className="img-title">{CONFIG.Original_Narrative}</h2>
                  </div>
                </div>
                <div className="col-md-9">
                  <div className="list-wrapper">
                  { this.props.getAllComplains.map((item,key)=>{
                  // console.log("LOOPCOMPLAINITEM");
                  // console.log(item);
                  //   console.log("LOOPSELECTEDLOCATIONS");
                  //   console.log(item.image_and_points[0].complainLocationData.selectedLocation);

                    setTimeout(()=>{
                      this.markPositionForLoop(item.image_and_points[item.image_and_points.length-1].complainLocationData.selectedLocation,key)
                    },1000);

                        return(

                            <div className="male-model-complain bg-white">
                              <div className="txt-content">
                                { key === 0 ? ReactHtmlParser(`${this.props.getAllComplains[this.props.getAllComplains.length-1].profileSummary}`) : null }
                              </div>
                              <h2 style={{ fontSize:18 }} className="img-title">{ item.image_and_points[item.image_and_points.length-1].complain_type_name } </h2>
                              <div className="container img-cont" style={{  background : 'white' }}>
                                <div className={`male-img male-img${key}`}>
                                  <img id="pic" src={ this.state.imgPath+item.image_and_points[item.image_and_points.length-1].complainLocationData.image} alt=""/>
                                </div>
                              </div> 
                              <div className="txt-content">
                                {ReactHtmlParser(sentenceCase(item.myNarrativeData))}
                              </div>
                            </div>

                        )
                      }) }
                      <div className="sec-btn patient--btn">

                        <Modal show={this.state.show} onHide={this.handleClose}>
                          <Modal.Header closeButton>
                            <Modal.Title id="contained-modal-title-vcenter">Patient Narrative</Modal.Title>
                          </Modal.Header>
                          <Modal.Body>
                            <Container>
                              <div className="sec-btn patient--btn">
                                <Link to="#" className="btn-img" onClick={this.handleUpdateAction}>
                                  <img
                                      src={require("../assets/img/icons/ic-incomplete-native.png")}
                                      alt=""
                                  />
                                  <span>Edit Complain</span>
                                </Link>

                                <Link to="#" className="btn-img" onClick={this.addAnotherNarrative}>
                                  <img
                                      src={require("../assets/img/icons/ic-complete-native.png")}
                                      alt=""
                                  />
                                  <span>Add Secondary Complain</span>
                                </Link>
                              </div>
                            </Container>
                          </Modal.Body>
                        </Modal>

                        <Link to={URLS.master} onClick={this.handleShow} className="btn-img">
                          <img
                              src={require("../assets/img/icons/ic-incomplete-native.png")}
                              alt=""
                          />
                          <span>{CONFIG.Incomplete_Narrative}</span>
                        </Link>

                        <Link to="#" className="btn-img" onClick={this.handleAction}>
                          <img
                              src={require("../assets/img/icons/ic-complete-native.png")}
                              alt=""
                          />
                          <span>{CONFIG.Accept_Narrative}</span>
                        </Link>

                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <div className="row">
            <div className="col-md-3" />
            <div className="col-md-9">

            </div>
          </div>
        </React.Fragment>
    );
  }
}

export default PatientNarrative;
